import { render, staticRenderFns } from "./CallList.vue?vue&type=template&id=7876e41b&scoped=true"
import script from "./CallList.vue?vue&type=script&lang=js"
export * from "./CallList.vue?vue&type=script&lang=js"
import style0 from "./CallList.vue?vue&type=style&index=0&id=7876e41b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7876e41b",
  null
  
)

export default component.exports